import { CompositePropagator, W3CTraceContextPropagator, W3CBaggagePropagator } from "@opentelemetry/core";
import { WebTracerProvider } from "@opentelemetry/sdk-trace-web";
import { Resource } from "@opentelemetry/resources";
import { ATTR_SERVICE_NAME } from "@opentelemetry/semantic-conventions";
import { BatchSpanProcessor } from "@opentelemetry/sdk-trace-base";
import { ZoneContextManager } from "@opentelemetry/context-zone";
import { OTLPTraceExporter } from "@opentelemetry/exporter-trace-otlp-http";
import { registerInstrumentations } from "@opentelemetry/instrumentation";
import { getWebAutoInstrumentations } from "@opentelemetry/auto-instrumentations-web";
import { Environment } from "../Infra/Environment";
class HxUiInstrumentation {
    constructor() {
        this.environment = new Environment();
        const enableInstrumentation = this.environment.ENABLE_INSTRUMENTATION === "true";
        if (enableInstrumentation) {
            console.log("Initializing OpenTelemetry...");
            const exporter = new OTLPTraceExporter({
                url: this.environment.OTEL_EXPORTER_URL,
                headers: {
                    "api-key": this.environment.NEW_RELIC_API_KEY,
                },
            });
            const provider = new WebTracerProvider({
                resource: new Resource({
                    [ATTR_SERVICE_NAME]: this.environment.OTEL_SERVICE_NAME,
                }),
                spanProcessors: [
                    new BatchSpanProcessor(exporter, {
                        maxQueueSize: 100,
                        maxExportBatchSize: 50,
                        scheduledDelayMillis: 200,
                        exportTimeoutMillis: 30000,
                    }),
                ],
            });
            provider.register({
                contextManager: new ZoneContextManager(),
                propagator: new CompositePropagator({
                    propagators: [new W3CBaggagePropagator(), new W3CTraceContextPropagator()],
                }),
            });
            registerInstrumentations({
                instrumentations: [
                    getWebAutoInstrumentations({
                        "@opentelemetry/instrumentation-xml-http-request": {
                            propagateTraceHeaderCorsUrls: [/^api(\.[a-z0-9-]+)?\.healthex\.(dev|io)$/, /^http:\/\/localhost:8000$/],
                            ignoreUrls: [/amazonaws\.com\//],
                        },
                        "@opentelemetry/instrumentation-fetch": {
                            propagateTraceHeaderCorsUrls: [/^api(\.[a-z0-9-]+)?\.healthex\.(dev|io)$/, /^http:\/\/localhost:8000$/],
                            ignoreUrls: [/amazonaws\.com\//],
                        },
                    }),
                ],
            });
        }
    }
    static get instance() {
        return this._instance;
    }
}
HxUiInstrumentation._instance = new HxUiInstrumentation();
export const Tracer = HxUiInstrumentation.instance;
